import { render, staticRenderFns } from "./StickerPackage.vue?vue&type=template&id=55fab14c&"
import script from "./StickerPackage.vue?vue&type=script&lang=js&"
export * from "./StickerPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports